<template>
	
	<div class="attivita-node">
		<!-- Header Attività -->
		<table class="table table-sm table-bordered mb-0" style="table-layout: fixed; width: 100%;">
			<colgroup>
				<col style="width: 3%;">
				<col style="width: 37%;">
				<col style="width: 5%;">
				<col style="width: 5%;">
				<col style="width: 7%;">
				<col style="width: 9%;">
				<col style="width: 7%;">
				<col style="width: 7%;">
				<col style="width: 7%;">
				<col style="width: 8%;">
				<col style="width: 5%;">
			</colgroup>
			<tbody>
				<tr class="attivita-row" :class="{ 'bg-danger bg-opacity-10 text-muted': attivita.FLG_ELIMINATO == 1 }">
					<!-- Colonna drag + expand -->
					<td class="p-1">
						<div class="d-flex align-items-center">
							<i v-show="dragEnabled" class="ph-dots-six-vertical drag-handle-attivita cursor-move me-1" title="Trascina per riordinare" @click.stop></i>
							<i :class="expanded ? 'ph-caret-down' : 'ph-caret-right'" class="cursor-pointer" :style="{ marginLeft: depth > 0 ? (depth * 24) + 'px' : '0px' }" @click="toggleExpanded"></i>
						</div>
					</td>

					<!-- TITOLO -->
					<td class="p-1" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;">
						<div class="d-flex align-items-center" :style="{ marginLeft: depth > 0 ? (depth * 24) + 'px' : '0px' }">
							<span v-if="attivita.COLORE" class="color-indicator me-1" :style="{ backgroundColor: attivita.COLORE }" title="Colore attività"></span>
							<span
								ref="tooltipCounter"
								class="me-1 text-muted"
								style="font-size:0.75rem; cursor: help;"
								@mouseenter="enableTooltip"
								@mouseleave="disableTooltip"
								@click.stop
							>
								{{ (attivita.VOCI || []).length }}v / {{ (attivita.SOTTO_ATTIVITA || []).length }}s
							</span>
							<Teleport to="body">
								<div v-if="showTooltip && tooltipContent" class="tooltip show" :style="tooltipStyle">
									<div class="tooltip-inner">
										{{ tooltipContent }}
									</div>
								</div>
							</Teleport>
							<span class="text-uppercase fw-semibold ms-2" style="word-wrap: break-word; white-space: normal;">
								{{ filters.accorciaTesto(attivita.TITOLO, 150) }}
							</span>
							<span v-if="attivita.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-2" style="font-size:0.65rem;">ESCLUSO</span>
						</div>
					</td>

					<!-- QUANTITÀ (empty for attività) -->
					<td class="p-1" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;"></td>

					<!-- GIORNI (empty for attività) -->
					<td class="p-1" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;"></td>

					<!-- PREZZO UNIT. (empty for attività) -->
					<td class="p-1" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;"></td>

					<!-- TOTALE BUDGET badge -->
					<td class="p-1 text-end" style="border-left: 1px solid #e8e8e8; border-right: 20px solid white !important;">
						<span v-if="attivita.SUBTOTALE_BUDGET > 0" class="badge bg-primary bg-opacity-20 text-primary" style="font-size: 0.7rem;">&euro; {{ attivita.SUBTOTALE_BUDGET }}</span>
					</td>

					<!-- COSTO UNIT. (empty for attività) -->
					<td class="p-1" style="border-left: 3px solid white !important; border-right: 1px solid #FFD648;"></td>

					<!-- COSTI ESPOSTO badge -->
					<td class="p-1 text-end" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;">
						<span v-if="attivita.SUBTOTALE_ESPOSTO > 0" class="badge bg-danger bg-opacity-20 text-danger" style="font-size: 0.7rem;">&euro; {{ attivita.SUBTOTALE_ESPOSTO }}</span>
					</td>

					<!-- COMMISSIONI PRIVATO badge -->
					<td class="p-1 text-end" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;">
						<span v-if="attivita.SUBTOTALE_PRIVATO > 0" class="badge bg-warning bg-opacity-20 text-warning" style="font-size: 0.7rem;">&euro; {{ attivita.SUBTOTALE_PRIVATO }}</span>
					</td>

					<!-- FORNITORE (empty for attività) -->
					<td class="p-1" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"></td>

					<!-- Azioni -->
					<td class="p-1">
						<div class="d-flex align-items-center justify-content-center" @click.stop>
							<!-- <ISwitch
								v-if="!readOnly && !dragEnabled"
								:size="'xs'"
								:modelValue="attivita.FLG_DA_CALCOLARE"
								@toggle="(val) => toggleFlgDaCalcolare(val)"
								title="Includi nel calcolo"
								style="z-index:0;"
								class="me-1"
							></ISwitch> -->

							<div v-if="!readOnly && !dragEnabled" class="dropdown" ref="dropdownEl">
								<a
									href="#"
									class="text-body p-0"
									@click.prevent="toggleDropdown"
									:aria-expanded="dropdownOpen"
									title="Azioni"
									ref="dropdownToggle"
								>
									<i class="ph-list"></i>
								</a>

								<!-- Teleport il menu dropdown fuori dalla gerarchia ricorsiva -->
								<Teleport to="body">
									<div
										v-if="dropdownOpen"
										class="dropdown-menu dropdown-menu-end show"
										:style="dropdownStyle"
										@click="handleMenuClick"
									>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')" @click.prevent="$emit('apri-azioni', { azione: 'modifica', attivita }); closeDropdown()">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
										</a>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')" @click.prevent="$emit('apri-azioni', { azione: 'aggiungi-voce', attivita }); closeDropdown()">
											<i class="far fa-plus-circle fa-fw me-2"></i><span class="text-muted me-1">|</span>Aggiungi Voce
										</a>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')" @click.prevent="$emit('apri-azioni', { azione: 'importa-voce-preferita', attivita }); closeDropdown()">
											<i class="fa fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span>Importa Voce Preferita
										</a>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('ATTIVITA_CREA')" @click.prevent="$emit('apri-azioni', { azione: 'aggiungi-sotto-attivita', attivita }); closeDropdown()">
											<i class="far fa-folder-plus fa-fw me-2"></i><span class="text-muted me-1">|</span>Aggiungi Sotto-attività
										</a>
										<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivo(attivita.FLG_ATTIVO == 1 ? 0 : 1); closeDropdown()">
											<i :class="attivita.FLG_ATTIVO == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ attivita.FLG_ATTIVO == 1 ? 'Disattiva' : 'Attiva' }}
										</a>
										<div class="dropdown-divider" v-if="$root.isGod && $root.hasFunzionalita('ATTIVITA_ELIMINA')"></div>
										<a href="#" class="dropdown-item text-danger" v-if="$root.hasFunzionalita('ATTIVITA_ELIMINA') && attivita.FLG_ELIMINATO != 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina', attivita }); closeDropdown()">
											<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina
										</a>
										<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && attivita.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina-definitivamente', attivita }); closeDropdown()">
											<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente
										</a>
										<a href="#" class="dropdown-item text-success" v-if="$root.isGod && attivita.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'ripristina', attivita }); closeDropdown()">
											<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina
										</a>
									</div>
								</Teleport>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Contenuto espandibile -->
		<div v-if="expanded" class="attivita-children">

			<!-- Tabella Voci con Draggable (sempre attiva per permettere drop) -->
			<div v-if="(dragEnabled || (attivita.VOCI && attivita.VOCI.length > 0)) && (!readOnly || (attivita.VOCI && attivita.VOCI.length > 0))" class="table-responsive">
				<table class="table table-bordered table-sm mb-0 voci-table" style="table-layout: fixed; width: 100%;">
					<colgroup>
						<col style="width: 3%;">
						<col style="width: 37%;">
						<col style="width: 5%;">
						<col style="width: 5%;">
						<col style="width: 7%;">
						<col style="width: 9%;">
						<col style="width: 7%;">
						<col style="width: 7%;">
						<col style="width: 7%;">
						<col style="width: 8%;">
						<col style="width: 5%;">
					</colgroup>
					<draggable
						:key="`voci-drag-${dragEnabled}-${attivita.ID_ATTIVITA}`"
						tag="tbody"
						:list="attivita.VOCI"
						handle=".drag-handle-voce"
					:disabled="!dragEnabled"
						group="voci"
						:animation="200"
						ghostClass="sortable-ghost"
						chosenClass="sortable-chosen"
						dragClass="sortable-drag"
					itemKey="ID_VOCE"
					:fallbackOnBody="true"
					:removeCloneOnHide="true"
						@start="onVoceDragStart"
						@end="onVoceDragEnd"
						@change="onVociChange"
						:move="onVoceMove"
						class="voci-container"
						:class="{
							'voci-empty': !attivita.VOCI || attivita.VOCI.length == 0,
							'voci-dropping': showVociDropZone
						}"
					>
						<!-- Placeholder quando vuoto e in drag -->
						<tr v-if="(!attivita.VOCI || attivita.VOCI.length == 0) && showVociDropZone" class="voce-drop-placeholder-row">
							<td colspan="11" class="text-center p-3">
								<div class="drop-placeholder">
									<span>Trascina qui</span>
								</div>
							</td>
						</tr>

						<!-- Voci -->
						<VoceNode
							v-for="voce in attivita.VOCI"
							:key="voce.ID_VOCE"
							:voce="voce"
							:depth="depth"
							:attivita="attivita"
							:read-only="readOnly"
							:drag-enabled="dragEnabled"
							@refresh="$emit('refresh')"
							@apri-azioni-voce="$emit('apri-azioni-voce', $event)"
						/>
					</draggable>
				</table>
			</div>

			<!-- Sotto-attività ricorsive con Draggable (sempre attivo per permettere drop) -->
			<draggable
				v-if="dragEnabled || (attivita.SOTTO_ATTIVITA && attivita.SOTTO_ATTIVITA.length > 0) && !readOnly"
				:key="`sotto-attivita-drag-${dragEnabled}-${attivita.ID_ATTIVITA}`"
				tag="div"
				:list="attivita.SOTTO_ATTIVITA"
				handle=".drag-handle-attivita"
				:disabled="!dragEnabled"
			group="attivita"
				:animation="200"
				ghostClass="sortable-ghost"
				chosenClass="sortable-chosen"
				dragClass="sortable-drag"
				itemKey="ID_ATTIVITA"
				:fallbackOnBody="true"
				:removeCloneOnHide="true"
				@start="onAttivitaDragStart"
				@end="onAttivitaDragEnd"
				@change="onSottoAttivitaChange"
				:move="onAttivitaMove"
				class="sotto-attivita-container"
				:class="{
					'sotto-attivita-empty': (!attivita.SOTTO_ATTIVITA || attivita.SOTTO_ATTIVITA.length == 0) && dragEnabled,
					'sotto-attivita-dropping': showAttivitaDropZone
				}"
			>
				<!-- Sotto-attività -->
				<AttivitaNode
					v-for="sub in attivita.SOTTO_ATTIVITA"
					:key="sub.ID_ATTIVITA"
					:attivita="sub"
					:depth="depth + 1"
					:progetto="progetto"
					:force-expanded="forceExpanded"
					:read-only="readOnly"
					:drag-enabled="dragEnabled"
					:dragging-voce-from-parent="draggingVoceFromParent"
					:dragging-attivita-from-parent="draggingAttivitaFromParent"
					@refresh="$emit('refresh')"
					@apri-azioni="$emit('apri-azioni', $event)"
					@apri-azioni-voce="$emit('apri-azioni-voce', $event)"
					@mark-unsaved-changes="$emit('mark-unsaved-changes')"
				/>
			</draggable>

			<!-- Versione read-only delle sotto-attività -->
			<div v-else>
				<AttivitaNode
					v-for="sub in attivita.SOTTO_ATTIVITA"
					:key="sub.ID_ATTIVITA"
					:attivita="sub"
					:depth="depth + 1"
					:progetto="progetto"
					:force-expanded="forceExpanded"
					:drag-enabled="dragEnabled"
					:read-only="readOnly"
					@refresh="$emit('refresh')"
					@apri-azioni="$emit('apri-azioni', $event)"
					@apri-azioni-voce="$emit('apri-azioni-voce', $event)"
					@drag-start="$emit('drag-start', $event)"
					@drag-end="$emit('drag-end')"
					@drag-feedback="$emit('drag-feedback', $event)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import VoceNode from '@/components/VoceNode.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import { useDropdownManager } from '@/composables/useDropdownManager.js'
import { ref } from 'vue'

export default {
	name: 'AttivitaNode',

	components: {
	/* 	ISwitch, */
		VoceNode,
		draggable: VueDraggableNext,
	},

	props: {
		attivita: {
			type: Object,
			required: true,
		},
		depth: {
			type: Number,
			default: 0,
		},
		progetto: {
			type: Object,
			required: true,
		},
		forceExpanded: {
			type: Boolean,
			default: null,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		dragEnabled: {
			type: Boolean,
			default: true,
		},
		draggingVoceFromParent: {
			type: Object,
			default: null,
		},
		draggingAttivitaFromParent: {
			type: Object,
			default: null,
		},
	},

	emits: ['refresh', 'apri-azioni', 'apri-azioni-voce'],

	watch: {
		forceExpanded: {
			immediate: true,
			handler(val) {
				if (val !== null) {
					this.expanded = val;
				}
			},
		},
	},

	setup() {
		const dropdownManager = useDropdownManager();
		const dropdownId = ref(null);
		const dropdownOpen = ref(false);
		const dropdownStyle = ref({});
		const dropdownToggle = ref(null);

		return {
			dropdownManager,
			dropdownId,
			dropdownOpen,
			dropdownStyle,
			dropdownToggle,
		};
	},

	data() {
		return {
			expanded: false,
			filters: global.filters,
			draggingVoce: null,
			draggingAttivita: null,
			showTooltip: false,
			tooltipStyle: {},
			tooltipContent: '',
			tooltipTimeout: null,
		}
	},

	computed: {
		// Mostra drop zone voci solo se:
		// 1. Sto trascinando una voce
		// 2. La voce NON proviene da questa stessa attività (cross-level)
		showVociDropZone() {
			const dragging = this.draggingVoce || this.draggingVoceFromParent;
			return dragging && dragging.sourceAttivitaId !== this.attivita.ID_ATTIVITA;
		},

		// Mostra drop zone attività solo se:
		// 1. Sto trascinando un'attività
		// 2. L'attività NON proviene da questa stessa attività parent (cross-level)
		showAttivitaDropZone() {
			const dragging = this.draggingAttivita || this.draggingAttivitaFromParent;
			return dragging && dragging.sourceParentId !== this.attivita.ID_ATTIVITA;
		},
	},

	mounted() {
		// Registra questo dropdown nel sistema centralizzato
		this.dropdownId = this.dropdownManager.registerDropdown(() => {
			this.closeDropdown();
		});

		// Gestisci click fuori dal dropdown per chiuderlo
		document.addEventListener('click', this.handleOutsideClick);
	},

	beforeUnmount() {
		// Pulisci il dropdown dal registro
		if (this.dropdownId) {
			this.dropdownManager.unregisterDropdown(this.dropdownId);
		}
		document.removeEventListener('click', this.handleOutsideClick);
	},

	methods: {
		enableTooltip() {
			// Cancella il timeout precedente
			if (this.tooltipTimeout) {
				clearTimeout(this.tooltipTimeout);
			}

			this.tooltipContent = `${(this.attivita.VOCI || []).length} Voci / ${(this.attivita.SOTTO_ATTIVITA || []).length} Sotto-attività`;
			this.showTooltip = true;

			this.$nextTick(() => {
				const element = this.$refs.tooltipCounter;
				if (element) {
					const rect = element.getBoundingClientRect();
					this.tooltipStyle = {
						position: 'fixed',
						top: `${rect.top - 40}px`,
						left: `${rect.left + rect.width / 2 - 50}px`,
						zIndex: '99999',
						transform: 'translateX(-50%)',
						pointerEvents: 'none', // Tooltip non cattura gli eventi del mouse
					};
				}
			});
		},

		disableTooltip() {
			// Usa timeout per evitare flickering quando il mouse passa sopra il tooltip
			this.tooltipTimeout = setTimeout(() => {
				this.showTooltip = false;
			}, 100);
		},

		toggleExpanded() {
			this.expanded = !this.expanded;
		},

		toggleDropdown() {
			if (this.dropdownOpen) {
				this.closeDropdown();
			} else {
				this.openDropdown();
			}
		},

		openDropdown() {
			// Notifica il manager per chiudere altri dropdown
			this.dropdownManager.openDropdown(this.dropdownId);
			this.dropdownOpen = true;

			// Calcola la posizione del dropdown
			this.$nextTick(() => {
				this.updateDropdownPosition();
			});
		},

		closeDropdown() {
			this.dropdownOpen = false;
			this.dropdownManager.closeDropdown(this.dropdownId);
		},

		updateDropdownPosition() {
			if (!this.$refs.dropdownToggle) return;

			const toggle = this.$refs.dropdownToggle;
			const rect = toggle.getBoundingClientRect();

			this.dropdownStyle = {
				position: 'fixed',
				top: `${rect.bottom + 2}px`,
				right: `${window.innerWidth - rect.right}px`,
				left: 'auto',
				zIndex: '99999',
			};
		},

		handleOutsideClick(event) {
			if (!this.dropdownOpen) return;

			const dropdownEl = this.$refs.dropdownEl;
			const toggle = this.$refs.dropdownToggle;

			if (dropdownEl && !dropdownEl.contains(event.target) &&
			    toggle && !toggle.contains(event.target)) {
				this.closeDropdown();
			}
		},

		handleMenuClick(event) {
			// Previeni la propagazione del click per evitare che chiuda il dropdown prematuramente
			event.stopPropagation();
		},

		toggleFlgDaCalcolare(newFlagValue) {
			utils.ajax('theb/attivita/updateFlagDaCalcolare', {
				ID_ATTIVITA: this.attivita.ID_ATTIVITA,
				FLG_DA_CALCOLARE: newFlagValue,
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Calcolo aggiornato con successo');
					this.$emit('refresh');
				}
			});
		},

		toggleFlgAttivo(newFlagValue) {
			const msg = newFlagValue == 1
				? 'Attivare questa attività e tutti i suoi figli (attività e voci)?'
				: 'Disattivare questa attività e tutti i suoi figli (attività e voci)?';

			utils.alert.confirm(msg, () => {
				utils.ajax('theb/attivita/updateFlagAttivo', {
					ID_ATTIVITA: this.attivita.ID_ATTIVITA,
					FLG_ATTIVO: newFlagValue,
				}, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Stato attivo aggiornato con successo');
						this.$emit('refresh');
					}
				});
			}, this.$root);
		},

		// ======= DRAG VOCI =======
		onVoceDragStart(evt) {
			document.body.classList.add('is-dragging');
			const voce = this.attivita.VOCI[evt.oldIndex];
			this.draggingVoce = {
				type: 'voce',
				item: voce,
				sourceAttivitaId: this.attivita.ID_ATTIVITA,
				sourceIndex: evt.oldIndex,
			};
		},

		onVoceDragEnd() {
			document.body.classList.remove('is-dragging');
			this.draggingVoce = null;
		},

		onVoceMove(evt) {
			// Blocca il movimento di attività (elementi con ID_ATTIVITA) nelle liste di voci
			if (evt.dragged && evt.dragged.ID_ATTIVITA !== undefined) {
				return false; // Blocca attività nelle liste voci
			}
			return true; // Permetti solo voci
		},

		onVociChange(evt) {
			// Aggiorna FK_ID_ATTIVITA per cross-level moves
			if (evt.added) {
				evt.added.element.FK_ID_ATTIVITA = this.attivita.ID_ATTIVITA;
			}

			// Il drag modifica già this.attivita.VOCI in place
			// Segna solo che ci sono modifiche non salvate
			this.$emit('mark-unsaved-changes');
		},


		// ======= DRAG ATTIVITÀ =======
		onAttivitaDragStart(evt) {
			document.body.classList.add('is-dragging');
			const attivita = this.attivita.SOTTO_ATTIVITA[evt.oldIndex];
			this.draggingAttivita = {
				type: 'attivita',
				item: attivita,
				sourceParentId: this.attivita.ID_ATTIVITA,
				sourceIndex: evt.oldIndex,
			};
		},

		onAttivitaDragEnd() {
			document.body.classList.remove('is-dragging');
			this.draggingAttivita = null;
		},

		onAttivitaMove(evt) {
			// Permetti il movimento tra drag-list diverse (cross-level, incluso root)
			return true;
		},

		onSottoAttivitaChange(evt) {
			// Aggiorna FK_ID_ATTIVITA per cross-level moves
			if (evt.added) {
				evt.added.element.FK_ID_ATTIVITA = this.attivita.ID_ATTIVITA;
			}

			// Il drag modifica già this.attivita.SOTTO_ATTIVITA in place
			// Segna solo che ci sono modifiche non salvate
			this.$emit('mark-unsaved-changes');
		},

	},
}
</script>

<style scoped>
/* Attività Row */
.attivita-row {
	background-color: rgb(222, 220, 220);
	border-bottom: 1px solid #999;
	transition: background-color 0.15s ease;
}

.attivita-row:hover {
	filter: brightness(0.98);
}

.attivita-row td {
	vertical-align: middle;
}

/* Drag Handle */
.drag-handle-attivita {
	opacity: 0.4;
	transition: opacity 0.2s;
}

.drag-handle-attivita:hover {
	opacity: 1;
}

/* Color Indicator */
.color-indicator {
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	border: 1px solid rgba(0, 0, 0, 0.2);
	flex-shrink: 0;
}

/* Sotto-attività container */
.sotto-attivita-container {
	min-height: 20px;
	margin: 2px 0;
	transition: all 0.2s ease;
}

/* Quando vuoto, mostra area per drop */
.sotto-attivita-container.sotto-attivita-empty {
	min-height: 50px;
	border: 2px dashed #ccc;
	border-radius: 4px;
	background-color: #f9f9f9;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}

.sotto-attivita-container.sotto-attivita-empty::before {
	content: "Trascina qui";
	color: #999;
	font-size: 0.75rem;
	font-weight: 400;
	user-select: none;
	pointer-events: none;
}

/* Quando si sta drappando */
.sotto-attivita-container.sotto-attivita-dropping {
	min-height: 30px;
}

/* Voci container */
.voci-container {
	min-height: 0px;
	margin: 2px 0;
	transition: all 0.2s ease;
}

/* Quando vuota */
.voci-container.voci-empty {
	min-height: 30px;
}

/* Quando si sta droppando */
.voci-container.voci-dropping {
	background: transparent;
	min-height: 30px;
}

.voce-drop-placeholder-row {
	background: transparent;
	border: none;
}


/* Sortable classes */
.sortable-ghost {
	opacity: 0.4;
	background: #f8f9fa;
}

/* Ghost più indentato quando dentro una sotto-attività */
.sotto-attivita-container .sortable-ghost {
	margin-left: 40px !important;
	border-left: 20px solid #2196f3;
	background: #e3f2fd;
	opacity: 0.6;
}

.sortable-chosen {
	opacity: 1;
	background: #e3f2fd;
}

.sortable-drag {
	opacity: 0.9;
	background: #ffffff;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
	cursor: grabbing !important;
}

/* Children Container */
.attivita-children {
	position: relative;
}

/* Fix dropdown visibility */
.table-responsive {
	overflow: visible !important;
}

.dropdown {
	position: relative;
}

/* Assicura che tutti gli elementi della tabella non blocchino i dropdown */
table, tbody, tr, td {
	overflow: visible !important;
}

/* Tabella Voci - Colori bordi laterali per Vendita e Acquisto */
.voci-table tbody tr td {
	text-align: right;
}

/* Colonna # ordine */
.voci-table tbody tr td:nth-child(1) {
	text-align: center;
}

/* VENDITA: Titolo (col 2) - bordi laterali bianco sporco */
.voci-table tbody tr td:nth-child(2) {
	text-align: left;
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

/* VENDITA: Q (col 3) - bordi laterali bianco sporco */
.voci-table tbody tr td:nth-child(3) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

/* VENDITA: G (col 4) - bordi laterali bianco sporco */
.voci-table tbody tr td:nth-child(4) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

/* VENDITA: Prezzo Unit (col 5) - bordi laterali bianco sporco */
.voci-table tbody tr td:nth-child(5) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

/* VENDITA: Totale Prezzo (col 6) - bordi laterali bianco sporco */
.voci-table tbody tr td:nth-child(6) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

/* ACQUISTO: Costo Unit Esposto (col 7) - bordi laterali giallo */
.voci-table tbody tr td:nth-child(7) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
}

/* ACQUISTO: Totale Esposto (col 8) - bordi laterali giallo */
.voci-table tbody tr td:nth-child(8) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
}

/* ACQUISTO: Costo Unit Privato (col 9) - bordi laterali giallo */
.voci-table tbody tr td:nth-child(9) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
}

/* ACQUISTO: Totale Privato (col 10) - bordi laterali giallo */
.voci-table tbody tr td:nth-child(10) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
}

</style>
